import { motion } from 'framer-motion';

interface Props {
  children: React.ReactNode;
  wide?: boolean;
}

export default function PageContainer({ children, wide }: Props) {
  return (
    <motion.div
      className={`${wide ? 'max-w-7xl' : 'max-w-5xl'} mx-auto space-y-6`}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18 }}
    >
      {children}
    </motion.div>
  );
}
